// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LimitOver.module.css */
.LimitOver_container__9tdr9 {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #111;
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  .LimitOver_card__JTyvi {
    background-color: #1a1a1a;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(255, 0, 0, 0.2);
    padding: 3rem;
    text-align: center;
    max-width: 500px;
    width: 100%;
    border: 1px solid #333;
    animation: LimitOver_fadeIn__aGN44 0.5s ease-in;
    position: relative;
    overflow: hidden;
  }
  
  .LimitOver_card__JTyvi::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(90deg, #ff1a1a, #ff4d4d);
  }
  
  .LimitOver_iconContainer__ivV3t {
    margin-bottom: 1.5rem;
  }
  
  .LimitOver_icon__-emse {
    height: 60px;
    width: 60px;
    color: #ff3333;
    margin: 0 auto;
  }
  
  .LimitOver_title__BCs6l {
    color: #ff3333;
    font-size: 2rem;
    margin-bottom: 1rem;
    font-weight: 700;
    letter-spacing: 0.5px;
  }
  
  .LimitOver_message__PAzGJ {
    color: #cccccc;
    font-size: 1rem;
    margin-bottom: 2rem;
    line-height: 1.5;
  }
  
  .LimitOver_buttonContainer__kgMpO {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  @media (min-width: 480px) {
    .LimitOver_buttonContainer__kgMpO {
      flex-direction: row;
      justify-content: center;
    }
  }
  
  .LimitOver_button__ecYVa {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s ease;
    flex: 1 1;
    display: inline-block;
    text-align: center;
    min-width: 120px;
  }
  
  .LimitOver_loginButton__HVkpM {
    background-color: transparent;
    color: #ffffff;
    border: 2px solid #ff3333;
  }
  
  .LimitOver_loginButton__HVkpM:hover {
    background-color: rgba(255, 51, 51, 0.1);
    transform: translateY(-2px);
  }
  
  .LimitOver_signupButton__D7rWb {
    background-color: #ff3333;
    color: #ffffff;
    border: 2px solid #ff3333;
  }
  
  .LimitOver_signupButton__D7rWb:hover {
    background-color: #ff4d4d;
    transform: translateY(-2px);
  }
  
  @keyframes LimitOver_fadeIn__aGN44 {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @media (max-width: 480px) {
    .LimitOver_card__JTyvi {
      padding: 2rem 1.5rem;
    }
    
    .LimitOver_title__BCs6l {
      font-size: 1.75rem;
    }
    
    .LimitOver_button__ecYVa {
      padding: 0.75rem 1rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/common/Limit Over/LimitOver.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;IAC5C,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,+CAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,oDAAoD;EACtD;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE;MACE,mBAAmB;MACnB,uBAAuB;IACzB;EACF;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,SAAO;IACP,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,oBAAoB;IACtB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,qBAAqB;IACvB;EACF","sourcesContent":["/* LimitOver.module.css */\n.container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    background-color: #111;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n  }\n  \n  .card {\n    background-color: #1a1a1a;\n    border-radius: 12px;\n    box-shadow: 0 10px 30px rgba(255, 0, 0, 0.2);\n    padding: 3rem;\n    text-align: center;\n    max-width: 500px;\n    width: 100%;\n    border: 1px solid #333;\n    animation: fadeIn 0.5s ease-in;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 6px;\n    background: linear-gradient(90deg, #ff1a1a, #ff4d4d);\n  }\n  \n  .iconContainer {\n    margin-bottom: 1.5rem;\n  }\n  \n  .icon {\n    height: 60px;\n    width: 60px;\n    color: #ff3333;\n    margin: 0 auto;\n  }\n  \n  .title {\n    color: #ff3333;\n    font-size: 2rem;\n    margin-bottom: 1rem;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n  }\n  \n  .message {\n    color: #cccccc;\n    font-size: 1rem;\n    margin-bottom: 2rem;\n    line-height: 1.5;\n  }\n  \n  .buttonContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  @media (min-width: 480px) {\n    .buttonContainer {\n      flex-direction: row;\n      justify-content: center;\n    }\n  }\n  \n  .button {\n    padding: 0.75rem 1.5rem;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    text-decoration: none;\n    transition: all 0.2s ease;\n    flex: 1;\n    display: inline-block;\n    text-align: center;\n    min-width: 120px;\n  }\n  \n  .loginButton {\n    background-color: transparent;\n    color: #ffffff;\n    border: 2px solid #ff3333;\n  }\n  \n  .loginButton:hover {\n    background-color: rgba(255, 51, 51, 0.1);\n    transform: translateY(-2px);\n  }\n  \n  .signupButton {\n    background-color: #ff3333;\n    color: #ffffff;\n    border: 2px solid #ff3333;\n  }\n  \n  .signupButton:hover {\n    background-color: #ff4d4d;\n    transform: translateY(-2px);\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .card {\n      padding: 2rem 1.5rem;\n    }\n    \n    .title {\n      font-size: 1.75rem;\n    }\n    \n    .button {\n      padding: 0.75rem 1rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LimitOver_container__9tdr9`,
	"card": `LimitOver_card__JTyvi`,
	"fadeIn": `LimitOver_fadeIn__aGN44`,
	"iconContainer": `LimitOver_iconContainer__ivV3t`,
	"icon": `LimitOver_icon__-emse`,
	"title": `LimitOver_title__BCs6l`,
	"message": `LimitOver_message__PAzGJ`,
	"buttonContainer": `LimitOver_buttonContainer__kgMpO`,
	"button": `LimitOver_button__ecYVa`,
	"loginButton": `LimitOver_loginButton__HVkpM`,
	"signupButton": `LimitOver_signupButton__D7rWb`
};
export default ___CSS_LOADER_EXPORT___;
